<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="is-paddingless section">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3" >
                  {{ $t('listeLotsComptable.title') }}
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb"/>
              </div>
            </div>
          </div>
          <a ref="lienDownload"></a>
        </div>
      </div>
    </div>
    <error-msg-component :messages="messages"
                         class="mgt-20px"
                         :error="error"
                         :title="'general.problemOccurred'"
                         :withEmplyFields="true"
                         @close="error = $event"/>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow">
            <selecteur-action
              @handleAction="handleAction"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="isSelected"
            ></selecteur-action>
          </div>
          <form @submit.prevent="recherche()"
                class="column is-5 pdr-0 pdl-0">
            <b-input :placeholder="$t('listeLotsComptable.actions.search')"
                     type="search" icon="magnify" v-model="critereRecherche.auto">
            </b-input>
          </form>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">
                {{$t('listeLotsComptable.actions.filter')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiserFiltre()"
                  class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right">
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table url="" :columns="columns" :options="options" :ref="referenceTable"
                    @loaded="finLoading" @loading="debutLoading" v-if="startArrayRendering"
                    class='tableWithChildRow'>
      <template slot='afterTable'>
        <table-items-in-view
          @input="$refs[referenceTable].setLimit($event)"
          :perPage="resultPerPage"/>
      </template>
      <div slot="selected" slot-scope="props" class="has-text-centered">
        <b-checkbox v-model="props.row.selected" :value="props.row">
        </b-checkbox>
      </div>
      <div slot="libelle" slot-scope="props">
        <router-link :to="{ name: 'c.comptabilite.lots_comptable', params: {id: props.row.id}}"
                     class="lien"
                     :class="{'text-access-no-permission':
                                   !checkPermissions(permLotsComptable.lecture)}">
          {{ props.row.libelle }}
        </router-link>
      </div>
      <div slot="creationTime" slot-scope="props">
        {{ props.row.creationTime | formatDate }}
      </div>
      <div slot="dateTransfert" slot-scope="props">
        {{ props.row.dateTransfert | formatDate }}
      </div>
      <div slot="nbrEcritures" slot-scope="props">
        <div class="is-pulled-right">
        {{ props.row.nbrEcritures }}
        </div>
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getEtatLot(props.row.etat)) }}
      </div>
      <div slot="montant" slot-scope="props" class="right">
        {{ getMontant(props.row.ifEcritures) | formatDevise }}
      </div>
       <div slot="supprimer" class="has-text-centered" slot-scope="props">
        <a @click="supprimerLot(props.row)">
            <b-icon
              icon="delete-forever"
              type="is-danger"
            >
            </b-icon>
        </a>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-lots-comptable ref="filtreListeLotcomptable"
                     @toggleFiltre="setShowFiltre"
                     v-model="critereRecherche"
                     @recherche="makeRechercheFilter"/>
    </div>
    <b-modal v-model="isComponentSupprimerLots"
             has-modal-card
             class="modal" @close="lotsToDelete = []">
      <app-supprimer-lot
        oncancel="closePopUpSupprimer"
        :messHeader="this.$t('supprimerLots.delete')"
        :messFooter="this.$t('supprimerLots.irreversible')"
        :cancel="this.$t('supprimerLots.no')"
        :validate="this.$t('supprimerLots.yes')"
        :messagesPopup="messagesPopup"
        :isErrorPopup.sync="isErrorPopup"
        @yes="HandlerSupprimerLot"
        @no="closePopUpSupprimer"
    />
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import messageSucces from '@/services/general/messageSucces';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import * as types from '@/store/modules/compta/journalEcriture-mutation-type';
import filtreLotsComptable from '@/components/compta/lotsComptable/filtreLotsComptable';
import {
  LISTE_ETAT, TRANSMIS, ACTION_TRANSFERE, ACTION_TRANSFERE_TASSER,
} from '@/configuration/compta/lotConf';
import SupprimerLot from '@/components/general/popUpPrevention';
import { remove } from '@/api/compta/ifLot/index';
import { transfere } from '@/api/compta/lot/index';
import validation from '@/services/compta/lot/validation';
import TableItemsInView from '@/components/general/TableItemsInView';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import subscribeMutation from '@/services/store/subscribeMutation';
import selecteurAction from '@/components/general/selecteurAction';
import { LOTS_COMPTABLE } from '@/configuration/compta/permissionsComptaConf';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_LOTS_COMPTABLE } from '@/configuration/general/referenceTableConf';

const societe = createNamespacedHelpers('societe');
const lotsComptable = createNamespacedHelpers('lotsComptable');
const Permissions = createNamespacedHelpers('permissions');

export default {
  data() {
    return {
      showFiltre: false,
      actions: [
        { action: ACTION_TRANSFERE, translation: 'listeLotsComptable.actions.transfere' },
        { action: ACTION_TRANSFERE_TASSER, translation: 'listeLotsComptable.actions.transfereTasser' },
      ],
      lotsToDelete: [],
      isComponentSupprimerLots: false,
      messagesPopup: [''],
      isErrorPopup: false,
      permLotsComptable: LOTS_COMPTABLE,
      unsubscribeValue: null,
      error: false,
      messages: [],
      startArrayRendering: false,
      referenceTable: REFERENCE_TABLE_LOTS_COMPTABLE,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
    this.unsubscribeValue();
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    breadcrumb() {
      const output = [
        { title: this.$i18n.t('listeLotsComptable.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('listeLotsComptable.title'), route: '', isActive: true },
      ];
      return output;
    },
    ...lotsComptable.mapGetters({
      items: 'items',
      totalCount: 'totalCount',
      getCriteresRecherche: 'criteresRecherche',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      lockMenu: 'lockMenu',
    }),
    critereRecherche: {
      get() {
        return this.getCriteresRecherche;
      },
      set(value) {
        return this.setCritereRecherche(value);
      },
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$t('listeLotsComptable.tab.libelle'),
          creationTime: this.$t('listeLotsComptable.tab.creationTime'),
          etat: this.$t('listeLotsComptable.tab.etat'),
          nbrEcritures: this.$t('listeLotsComptable.tab.nbrEcritures'),
          dateTransfert: this.$t('listeLotsComptable.tab.interfaceCompta'),
          montant: this.$t('listeLotsComptable.tab.montant'),
          selected: (h) => {
            return h(
              'a', {
                attrs: {
                  class: 'pointer',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
          supprimer: '',
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          data.query = this.critereRecherche;
          data.query.societeId = this.societeActiveId;
          return this.actionsLoadLotsComptable(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
        sortable: ['libelle', 'etat', 'creationTime', 'montant'],
        columnsClasses: {
          selected: 'colonneSelected',
          supprimer: 'colonneSelected',
        },
      };
    },
    columns() {
      return ['selected', 'libelle', 'creationTime', 'etat', 'nbrEcritures', 'dateTransfert', 'montant', 'supprimer'];
    },
    nombreCritere() {
      let nombreCritere = 0;
      if (this.critereRecherche.etat != null) {
        nombreCritere += 1;
      }
      return nombreCritere <= 9 ? nombreCritere : '+9';
    },
    isAllSelected() {
      return !this.items.map(item => item.selected).includes(false);
    },
    isSelected() {
      return this.items.map(item => item.selected).includes(true);
    },
    iconSelectTotal() {
      if (this.isAllSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
  },
  components: {
    AppBreadcrumb: breadcrumb,
    filtreLotsComptable,
    appSupprimerLot: SupprimerLot,
    selecteurAction,
    TableItemsInView,
    errorMsgComponent,
    parametrageTable,
  },
  methods: {
    ...lotsComptable.mapMutations({
      setCritereRecherche: types.SET_CRITERE,
    }),
    ...lotsComptable.mapActions({
      actionsLoadLotsComptable: 'loadLotsComptable',
    }),
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    async reinitialiserFiltre() {
      await this.$refs.filtreListeLotcomptable.initializeFiltre();
      await this.$refs.filtreListeLotcomptable.viderCritere();
      await this.$refs.filtreListeLotcomptable.appliquerCritere();
      this.showFiltre = false;
    },
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreListeLotcomptable.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.setShowFiltre();
      this.recherche();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    getEtatLot(etat) {
      return LISTE_ETAT.find(el => el.code === etat).libelle;
    },
    selectAll() {
      const select = !this.isAllSelected;
      this.items.forEach(item => {
        item.selected = select;
      });
    },
    async transfere(tasser) {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.messages = [];
        const listeLot = this.items.filter(item => item.selected).map(item => item.id);
        const response = await transfere(listeLot, tasser);
        if (response.status === 206) {
          const msg = this.$i18n.t('listeDetailLotsComptable.msgSuccess.nbrLot');
          messageSucces(response.data.result ? response.data.result : 0 + ' ' + msg);
        }
        if (response.status === 200) {
          const file = new File(
            [response.data], '',
            { type: response.request.getResponseHeader('Content-Type') },
          );
          const link = this.$refs.lienDownload;
          link.href = window.URL.createObjectURL(file);
          const disposition = response.request.getResponseHeader('Content-Disposition');
          link.download = decodeURI(disposition.match(/filename\*=UTF-8''(.*?)$/)[1]);
          link.click();
          const msg = this.$i18n.t('listeDetailLotsComptable.msgSuccess.fileTransmis');
          messageSucces(msg);
        }
        this.recherche();
        loadingComponent.close();
      } catch (e) {
        if (e.response && e.response.data.error.validationErrors) {
          validation(e.response, this.messages);
          this.error = true;
        } else messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
    },
    async handleAction(action) {
      if (action === ACTION_TRANSFERE) await this.transfere(false);
      if (action === ACTION_TRANSFERE_TASSER) await this.transfere(true);
    },
    rechargementSuiteSuppression() {
      this.isComponentSupprimerLots = false;
      this.lotsToDelete = [];
      this.recherche();
    },
    supprimerLot(lotToDelete) {
      this.lotsToDelete.push(lotToDelete);
      this.isComponentSupprimerLots = true;
    },
    closePopUpSupprimer() {
      this.isComponentSupprimerLots = false;
      this.messagesPopup = [];
      this.lotsToDelete = [];
      this.isErrorPopup = false;
    },
    async HandlerSupprimerLot() {
      this.isErrorPopup = false;
      this.messagesPopup = [];
      const countLotTansmis = this.lotsToDelete
        .filter((el) => { return el.etat === TRANSMIS; }).length;

      if (countLotTansmis > 0) {
        this.isErrorPopup = true;
        this.messagesPopup.push({
          message: 'supprimerLots.messages.errorTransmis',
        });
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        const promises = [];
        this.lotsToDelete.forEach((lot) => { promises.push(remove(lot.id)); });
        await Promise.all(promises);
        this.isComponentSupprimerLots = false;
        this.rechargementSuiteSuppression();
        loadingComponent.close();
        messageSucces(this.$i18n.t('supprimerLots.messages.deleteSuccess'));
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
    getMontant(ifEcritures) {
      let montant = 0;
      ifEcritures.forEach((ecriture) => {
        montant += ecriture.totalTtcPiece;
      });
      return montant;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.unsubscribeValue = await subscribeMutation(this.$store, 'societe/' + SET_DETECT_CHANGE_SOCIETE, this.recherche, this.goFirstPage);
      this.setInformationPage(this.$t('pageCompta.lots.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
